import { classNames, tw, twMerge } from '@panwds/tailwindcss';
import React, { forwardRef } from 'react';
import { SelectWithoutSearch } from '../Select/SelectWithoutSearch.js';
import { TruncateText } from '../TruncateText/index.js';
const sizes = {
    sm: tw `twds-text-xs`,
    md: tw `twds-text-xs`,
    lg: tw `twds-text-sm`
};
const height = {
    sm: tw `twds-h-4`,
    md: tw `twds-h-4`,
    lg: tw `twds-h-6`
};
const horizontalPadding = {
    sm: tw `twds-pl-[0.44rem] twds-pr-2 twds-py-[0.1875rem]`,
    md: tw `twds-pl-[0.94rem] twds-pr-4 twds-py-[0.1875rem]`,
    lg: tw `twds-pl-[0.94rem] twds-pr-4 twds-py-[0.1875rem]`
};
const rootClassName = (size = 'md', readOnly = false) => classNames('twds-flex twds-items-center twds-h-full', 'twds-border-gray-300 dark:twds-border-gray-500/30', 'twds-border-solid twds-border twds-rounded twds-rounded-r-none twds-box-border', 'twds-p-y-3', 'twds-border-t-0 twds-border-r-1 twds-border-b-0 twds-border-l-0', !readOnly && 'twds-bg-black dark:twds-bg-white twds-bg-opacity-[0.04] dark:twds-bg-opacity-[0.04]', horizontalPadding[size]);
export const InputPrefix = forwardRef(({ addClassName, readOnly, size = 'md', value }, userRef) => {
    const inputClassName = classNames('twds-text-gray-600 dark:twds-text-gray-300 twds-text-center twds-border-0', 'focus:twds-outline-none twds-bg-transparent twds-p-0 twds-flex', sizes[size]);
    return (React.createElement("div", { className: twMerge(rootClassName(size, readOnly), addClassName) },
        React.createElement("div", { className: inputClassName, ref: userRef },
            React.createElement(TruncateText, null, value))));
});
export const SelectPrefix = ({ addClassName, items, onChange, readOnly, value, size = 'md' }) => {
    const selectClassName = classNames('twds-text-gray-600 dark:twds-text-gray-300 twds-text-center twds-border-0', 'focus:twds-outline-none twds-p-0', 'twds-border-none twds-bg-transparent twds-pl-0 twds-pr-0 twds-py-0', 'twds-bg-black dark:twds-bg-white twds-bg-opacity-0 dark:twds-bg-opacity-0', 'active:twds-bg-transparent hover:twds-bg-transparent focus-within:twds-bg-transparent', 'active:dark:twds-bg-transparent hover:dark:twds-bg-transparent focus-within:dark:twds-bg-transparent [&>:last-child]:twds-justify-items-center', sizes[size], height[size]);
    return (React.createElement("div", { className: twMerge(rootClassName(size, readOnly), addClassName) },
        React.createElement(SelectWithoutSearch, { addButtonClassName: selectClassName, menuStyle: { transform: 'translate(-15.5px, 8px)', minWidth: '88px' }, items: items, selectedItem: value, onChange: onChange })));
};
export const PrefixWrapper = ({ addClassName, readOnly, children, size = 'md' }) => {
    return React.createElement("div", { className: twMerge(rootClassName(size, readOnly), addClassName) }, children);
};
//# sourceMappingURL=prefix.js.map